import { nanoid } from 'nanoid/non-secure';

import { MESSAGES, ROLE } from '../../constants';

export interface IImage {
  id: string;
  type: MESSAGES.IMAGE;
  src: string;
  rm: boolean;
  nodeId: string;
  avatar: boolean;
  role: ROLE.BOT;
}

export const createImage = (data): IImage => {
  return {
    id: nanoid(),
    type: MESSAGES.IMAGE,
    src: data.src,
    rm: Boolean(data.rm),
    nodeId: data.nodeId,
    avatar: true,
    role: ROLE.BOT,
  };
};
